<template>
    <div class="order_div">
        <v-header></v-header>
        <div class="mbx">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }" alt="小查线索">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/myOrder" alt="我的订单">我的订单</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="order_dom">
            <el-table :data="tableObj" border style="width: 100%">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="setmealName" label="产品名称"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="orderId" label="订单编号"></el-table-column>
                <el-table-column label="平台">
                    <template slot-scope="scope">
                        <span v-if="parseInt(scope.row.whereFrom) == 3">微信小程序</span>
                        <span v-if="parseInt(scope.row.whereFrom) == 4">H5</span>
                        <span v-if="parseInt(scope.row.whereFrom) == 2">app</span>
                        <span v-if="parseInt(scope.row.whereFrom) == 1">PC官网</span>
                        
                    </template>
                </el-table-column>
                <el-table-column label="支付方式">
                    <template slot-scope="scope">
                        <span v-if="parseInt(scope.row.orderMethod) == 1">微信</span>
                        <span v-if="parseInt(scope.row.orderMethod) == 2">支付宝</span>
                    </template>
                </el-table-column>
                <el-table-column prop="date" label="支付状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderStatus == 1" style="color: #f00;">未支付</span>
                        <span v-if="scope.row.orderStatus == 2">充值成功</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import vHeader from './common/header.vue'
export default {
    data(){
        return{
            tableObj:[]
        }
    },
    components:{
        vHeader
    },
    methods:{
        initFun(){
			var _this = this;
            this.getRequest('api/clurOrder/getAllByUserId',{}).then(res=>{
                var data = res.data;
				if(data.status == 200){
					_this.tableObj = data.obj;
                    console.log(data)
				}
            })
        }
    },
    mounted(){
        this.initFun();
    }
}
</script>
<style lang="scss" scoped>
body {
    background-color: #F0F2F5;
}
.order_div{
    width: 100%;
    height: auto;
}

.mbx{
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    a{
        cursor: default !important;
    }
}

.order_dom{
    height: auto;
    margin: 0 auto;
    cursor: default;
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/myOrder.vue